module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/remotejob-679ceafb14ef1ef577580a816e0c6f00.jpg";